import { FC } from 'react'
import { graphql } from 'relay-runtime'
import { useFragment } from 'react-relay/hooks'
import Image from 'next/image'
import { PostContent } from '@lifedot/components/PostContent'
import { css } from '@emotion/react'
import { mq } from '@lifedot/styles/mediaQuery'
import { replacePostBody } from '@/utils/replacePostBody'
import { PostNoTitle_post$key } from './__generated__/PostNoTitle_post.graphql'
import { replaceShortCode } from '@/utils/replaceShortCode'

const styles = {
  img: css({
    position: 'relative',
    paddingTop: '33.3%'
  }),
  content: css({
    padding: 40,
    [mq('sp')]: {
      padding: 12
    }
  })
}

interface PostNoTitleProps {
  post: PostNoTitle_post$key | null
}

export const PostNoTitle: FC<PostNoTitleProps> = ({ post }) => {
  const data = useFragment(fragment, post)
  if (!data) return null

  return (
    <article>
      <h1>
        {data.image && (
          <div css={styles.img}>
            <Image
              src={data.image.url}
              priority
              alt={data.image.alt || data.h1}
              layout="fill"
              objectFit="cover"
            />
          </div>
        )}
      </h1>
      <section css={styles.content}>
        <PostContent
          contentHtml={replacePostBody(
            data.content_text,
            data.shortcodes,
            data.template_name
          )}
          replace={replaceShortCode}
        />
      </section>
    </article>
  )
}

const fragment = graphql`
  fragment PostNoTitle_post on Post {
    h1
    content_text
    template_name
    image {
      url
      alt
    }
    shortcodes {
      index
      category
      code
      params {
        key
        value
      }
    }
  }
`
